(()=>{
 if(window.terrorWebsitePresence)return;
 const state=window.terrorWebsitePresence={count:null,actualCount:null};
 let displayTimer=null,displayed=null,presentation=false;
 try{const old=JSON.parse(sessionStorage.getItem('tt-presence-display'));if(old&&Date.now()-old.at<600000&&Number.isInteger(old.count)&&old.count>=7&&old.count<=21){displayed=old.count;presentation=old.presentation===true;}}catch{}
 function render(tick=false){
  const actual=state.actualCount;
  if(Number.isInteger(actual)){
   if(actual>21){displayed=actual;presentation=false;}
   else if(actual<7){
    if(!presentation){displayed=Number.isInteger(displayed)?Math.max(7,Math.min(21,displayed)):7;presentation=true;}
    else if(tick){const step=Math.random()<0.5?-1:1;displayed=Math.max(7,Math.min(21,displayed+step));}
   }else if(presentation){
    if(tick)displayed+=Math.sign(actual-displayed);
    if(displayed===actual)presentation=false;
   }else displayed=actual;
   try{sessionStorage.setItem('tt-presence-display',JSON.stringify({count:displayed,presentation,at:Date.now()}));}catch{}
  }
  state.count=Number.isInteger(actual)?displayed:null;
  window.dispatchEvent(new CustomEvent('terror-website-presence',{detail:{count:state.count}}));
 }
 function scheduleDisplay(){clearTimeout(displayTimer);displayTimer=setTimeout(()=>{render(true);scheduleDisplay();},90000+Math.floor(Math.random()*90001));}
 render();scheduleDisplay();
 let visitor=crypto.randomUUID(),socket,heartbeat,retry,attempt=0;
 try{visitor=localStorage.getItem('tt-website-visitor')||visitor;localStorage.setItem('tt-website-visitor',visitor);}catch{}
 function publish(count){state.actualCount=count;render();}
 function stop(){clearTimeout(retry);clearInterval(heartbeat);const old=socket;socket=null;old?.close();publish(null);}
 function connect(){
  if(document.hidden||socket)return;
  socket=new WebSocket('wss://global-terror-skate-rust.fvc3less.workers.dev/website-presence?visitor='+encodeURIComponent(visitor));
  const current=socket;
  current.onopen=()=>{if(socket!==current)return;attempt=0;heartbeat=setInterval(()=>{if(current.readyState===1)current.send('ping');},25000);};
  current.onmessage=event=>{if(socket!==current)return;try{const data=JSON.parse(event.data);if(data.type==='website-presence'&&Number.isInteger(data.count)&&data.count>=0)publish(data.count);}catch{}};
  current.onclose=()=>{if(socket!==current)return;socket=null;clearInterval(heartbeat);publish(null);if(!document.hidden)retry=setTimeout(connect,Math.min(30000,1000*2**attempt++)+Math.random()*500);};
  current.onerror=()=>current.close();
 }
 document.addEventListener('visibilitychange',()=>document.hidden?stop():connect());
 window.addEventListener('pagehide',stop);window.addEventListener('pageshow',connect);window.addEventListener('online',connect);
 connect();
})();
